import styled from "styled-components";

export const HeroSection = styled.section`
  padding: 32px 80px 80px;
  background: #101015;
  color: #fff;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 80px 24px 24px;
  }
`;

export const HeroContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
  padding-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
    padding-top: 24px;
  }
`;

export const EyebrowText = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 12px;
`;

export const HeroText = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    font-size: 65px;
    margin-bottom: 16px;
    color: #fff;
    font-family: 'Playfair Display', serif;
    font-weight: 500;
    line-height: 1.2;
    
    @media (max-width: 768px) {
      font-size: 36px;
    }
  }

  p {
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 24px;
    color: #FAFAFA;
    white-space: pre-line;
    
    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 26px;
    }
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    border: none;
    background: #1a1a1a;
    color: #FFF;
    cursor: pointer;
    font-size: 18px;
    font-weight: 500;
    border-radius: 999px;
    transition: transform 0.3s ease, background 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      background: #f5f5f5;
      color: #000;
      
      .arrow-container {
        background: #000;
        color: #fff;
      }
    }

    .arrow-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: #FFF;
      color: #000;
      border-radius: 50%;
      transition: all 0.3s ease;
    }
  }
`;

export const HeroImage = styled.div`
  position: relative;
  text-align: right;
  width: 100%;
  height: 600px; /* Fixed height for container */

  img {
    width: 90%;
    height: 100%; /* Take full height of container */
    object-fit: cover; /* This prevents stretching - maintains aspect ratio */
    object-position: center; /* Center the image within the container */
    margin-top: 20px;
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
    
    @media (max-width: 768px) {
      width: 100%;
      height: 400px; /* Adjusted height for mobile */
      object-fit: cover; /* Maintain on mobile too */
    }
  }

  @media (max-width: 768px) {
    height: 400px; /* Adjust container height for mobile */
  }
`;